import { useSelector } from "react-redux";
import AccountRepository from "src/repository/Admin/AccountRepository";
import { getAccountList, getAccountDetail, getAccountUserList, setAccountList } from "src/store/slice/model/Admin/Account";
import store from "src/storeWire";


export function useAccountStore() {
    const accountList = useSelector((state) => state.entities.model_Admin_Account_list.accountList)
    const totalRecords = useSelector((state) => state.entities.model_Admin_Account_list.totalRecords)
    const filteredRecords = useSelector((state) => state.entities.model_Admin_Account_list.filteredRecords)
    const accountDetail = useSelector((state) => state.entities.model_Admin_Account_list.accountDetail)
    const accountUserList = useSelector((state) => state.entities.model_Admin_Account_list.accountUserList)
    const totalAccountUser = useSelector((state) => state.entities.model_Admin_Account_list.totalAccountUser)
    const filteredAccountUsers = useSelector((state) => state.entities.model_Admin_Account_list.filteredAccountUsers)

    let data = {
        accountList,
        totalRecords,
        filteredRecords,
        accountDetail,
        accountUserList,
        totalAccountUser,
        filteredAccountUsers
    };

    let fetch = {
        get_account_list: async (params) => {
            return await store.dispatch(getAccountList(params))
        },
        get_account_detail: async (accountId) => {
            return await store.dispatch(getAccountDetail(accountId))
        },
        get_account_user_list: async (params) => {
            return await store.dispatch(getAccountUserList(params))
        },

        get_account_export: async (params) => {
            return await new AccountRepository().getAccountExport(params);
        },
        export_account_user_list: async (params) => {
            return await new AccountRepository().exportAccountUsrList(params);
        },
        email_accouts: async (params) => {
            return await new AccountRepository().emailAccounts(params);
        },
        email_account_user_list: async (params) => {
            return await new AccountRepository().emailAccountUserList(params);
        }
    };
    let set = {
        set_account_list: () => {
            return store.dispatch(setAccountList([]));
        },

        update_unsponsor_acct_by_user: async (params) => {
            return await new AccountRepository().updateUnsponsorAcctByUser(params);
        },
    };
    return [data, fetch, set]
}